export enum InternalTabTypes {
    QualificationTab = "Qualification",
    PhysicalAddressTab = "Physical Address",
    MailingAddressTab = "Mailing Address",
    LicenseTab = "License",
    ConfirmationTab = "Confirmation",
    SignatureTab = "Signature",
    PaymentTab = "Payment",
    VerificationTab = "Verification",
    UploadTab = "Upload",
    RequestcopyTab = "Request a Copy",
}

export enum ApplicationTypes {
    InitialApplication = "INITIAL",
    SubsequentApplication = "SUBSEQUENT",
    RenewalApplication = "RENEWAL",
    SubsequentRenewalApplication = "SUBRENEWAL",
    ReinstatementsApplication = "REINSTATE",
    SubsequentReinstatementApplication = "SUBREINSTATE",
    VoluntaryRevocation = "VOLREVOCATION",
    RequestaCopy = "RECOPY",
    ChangeofAddress = "CHANGEADDRESS",
    Corrections = "CORRECTION",
}

export interface QualificationTab {
    externalStatusTypeId: any;
    requestStatusTypeId: any;
    id: number;
    qualificationType: number;
    entityControlNumber: string;
    fein: string;
    firstName: string;
    middleName: string;
    lastName: string;
    birthDate: Date;
    lastFourSocialSecurityNumber: string;
    phoneNumber: string;
    phoneExtension: string;
    email: string;
}

export interface PhysicalAddressTab {
    externalStatusTypeId: any;
    requestStatusTypeId: any;
    id: number;
    address1: string;
    addres2: string;
    address3: string;
    city: string;
    validateAddress: string;
    state: number;
    zipCode: string;
    useAsMailingAddress: boolean;
}

export interface MailingAddressTab {
    externalStatusTypeId: any;
    requestStatusTypeId: any;
    id: number;
    address1: string;
    addres2: string;
    address3: string;
    city: string;
    validateAddress: string;
    state: number;
    zipCode: string;
}

export interface LicenseTab {
    externalStatusTypeId: any;
    id: number;
    hasActiveStateLicense: boolean;
    stateLicenseNumber: string;
    stateLicenseExpirationDate: string;
    cspLicense: string;
    cspLicenseId: any;
    county: number;
    countyLicenseNumber: string;
    countyLicenseExpirationDate: string;
    city: number;
    cityLicenseNumber: string;
    cityLicenseExpirationDate: string;
    requestStatusTypeId: any
}

export interface SignatureTab {
    requestStatusTypeId: any;
    externalStatusTypeId: any;
    id: number;
    firstName: string;
    middleInitial: string;
    lastName: string;
    title: string;
    suffix: string;
    iCertify: boolean;
}

export interface ConfirmationTab {
    requestStatusTypeId: any;
    externalStatusTypeId: any;
    id: number;
    attestToTCA: boolean;
    waveRightsToSue: boolean;
    doHaveInjury: any;
}

export interface PaymentTab {
    id: number;
    payrefund: boolean;
    PaymentTypeId: any;
    CheckNumber: any;
    amount: any;
    exemptionFilingRequestId: number;
    requestStatusTypeId: any;
    externalStatusTypeId: any;
    paymentTypeId: number;
    exemptionFilingId?: any;
    checkNumber: string;
    fisTransactionId?: any;
    fisAuthorizationNumber?: any;
    fisPaymentType?: any;
    fisBillingName?: any;
    fisBillingAddress?: any;
    fisBillingCity?: any;
    fisBillingState?: any;
    fisBillingZip?: any;
    fisBillingEmail?: any;
    fisBillingPhone?: any;
    createdBy: number;
    createdDate: Date;
    modifiedBy: number;
    modifiedDate: Date;
    deletedBy?: any;
    deletedDate?: any;
}
export interface HistoryItem {
    exemptionFilingId: any;
    exemptionRequestId: any;
    createdByApplicationUser: any;
    id: number;
    summary: any;
    detail: any;
    createdBy: number;
    createdDate: Date;
}